// extracted by mini-css-extract-plugin
export default {"button":"button_button__d4Oxx","gradientStart":"button_gradientStart__ESgNe","gradientAnimation":"button_gradientAnimation__Rxs7y"};